import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  InputAdornment,
  MenuItem,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import React, {
  ChangeEvent,
  useEffect,
  useRef,
  useState,
  SetStateAction,
  Dispatch,
} from 'react';
import { QueryCache, useMutation, useQuery, useQueryClient } from 'react-query';
import { useRecoilValue } from 'recoil';
import { useSession, xapi } from '../../hooks/session';
import { MultilineTextField } from '../styles/Styles';
import { SwDatesPicker } from './dateSetting/SwDatesPicker';
import { SwSnackbar } from './views/SwSnackbar';
import { SwAlert } from './views/SwAlert';
import { RESULT_OK } from '../../common/resultCode';
import {
  MobileRegexp,
  commaFormat,
  educationOffices,
  getReadGoal,
  getSchoolClassCount,
  getSchoolGradeCount,
  getSchoolInSchoolGroup,
  getWalkGoal,
  schoolGroups,
} from '../../common/helper';
import { SwConfirmDialog } from './views/SwConfirmDialog';
import { SwImageBox } from './others/SwImageBox';
import excellog from '../../images/sub/excel_icon.svg';
import folderlog from '../../images/sub/folder_icon.svg';
import { SwThumbImageCategoryView } from './SwThumbImageCategoryView';
import { schoolListState } from '../../common/atom';
import {
  KEY_SCHOOL_GRADE_SCHOOL_CLASS_LIST,
  KEY_SCHOOL_LIST,
} from '../../common/key';
import { getSchoolGradeSchoolClassList } from '../../common/api/ApiSchool';

interface Props {
  open: boolean;
  onClose: () => void;
  isAdd: boolean;
  bookGroupInfo: any;
  onSave: (data: any) => void;
  onDelete: (data: any) => void;
}

export const SwBookGroup: React.FC<Props> = ({
  open,
  onClose,
  isAdd,
  bookGroupInfo,
  onSave,
  onDelete,
}) => {
  const { loginVal } = useSession();
  const [schoolList, setSchoolList] = useState<any[]>([]);
  const [bookGroupSeq, setBookGroupSeq] = useState<number>(0);
  const [bookGroupName, setBookGroupName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [schools, setSchools] = useState<any[]>([]);
  const [educationOfficeSeq, setEducationOfficeSeq] = useState<number>(1);
  const [schoolSeq, setSchoolSeq] = useState<number>(0);
  const [schoolClassSeq, setSchoolClassSeq] = useState<number>(0);
  const [schoolGroupSeq, setSchoolGroupSeq] = useState<number>(1);
  const [schoolGrade, setSchoolGrade] = useState<number>(1);
  const [schoolClass, setSchoolClass] = useState<string>('1');
  const [customSchoolClass, setCustomSchoolClass] = useState<string>('');
  const [schoolName, setSchoolName] = useState<string>('');
  const [schoolClassList, setSchoolClassList] = useState<any[]>([]);
  const [tabValue, setTabValue] = React.useState(0);
  const [uploadFile, setUploadFile] = useState<any>();
  const [imageUrl, setImageUrl] = useState<string>('');
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<any>();
  const [alertTitle, setDialogTitle] = useState<string>('');
  const [dialogMessage, setDialogMessage] = useState<string>('');
  const [snackbarMessage, setSnackbarMessage] = useState<string>('');
  const [openSnackbar, setOpenSnackbar] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState<number>(0);
  const [openBookGroupCategory, setOpenBookGroupCategory] =
    useState<boolean>(false);

  const { refetch: schoolClassRefetch } = useQuery(
    KEY_SCHOOL_GRADE_SCHOOL_CLASS_LIST,
    () => {
      const newData: any = {
        schoolSeq: schoolSeq,
        schoolGrade: schoolGrade,
      };
      if (schoolSeq > 0) return getSchoolGradeSchoolClassList(newData);
      return null;
    },
    {
      onSuccess: res => {
        if (res !== null && res.schoolClassList !== undefined) {
          setSchoolClassList(res.schoolClassList);
        }
      },
      onError: e => {
        console.log(e);
      },
    }
  );

  const reloadSchools = (
    newSchoolList: any[],
    newSchoolGroupSeq: number,
    newEducationOfficeSeq: number
  ) => {
    const newSchools = getSchoolInSchoolGroup(
      newSchoolList,
      newSchoolGroupSeq,
      newEducationOfficeSeq
    );
    setSchools(newSchools);
  };

  const showError = (msg: string) => {
    setOpenSnackbar(true);
    setAlertMessage(msg);
  };

  const downloadSampleExcel = () => {
    const url =
      'https://d15wsbb3qf2hxa.cloudfront.net/common/%EB%8F%84%EC%84%9C%EB%AA%A9%EB%A1%9D_%EC%97%91%EC%85%80%EC%97%85%EB%A1%9C%EB%93%9C%EC%9A%A9_%EC%96%91%EC%8B%9D.xlsx';
    const a = document.createElement('a');
    a.href = url;
    a.download = `도서목록업로드양식.xlsx`;
    document.body.appendChild(a);
    a.click();
    setTimeout((_: any) => {
      window.URL.revokeObjectURL(url);
    }, 60000);
    a.remove();
  };

  const uploadExcelFile = (evt: ChangeEvent<HTMLInputElement>) => {
    const excelFile = evt.target.files && evt.target.files[0];

    var formData = new FormData();
    if (excelFile !== null) formData.append('file', excelFile);

    xapi.post(`/admin/v1/apis/book/upload/book-group`, formData).then(res => {
      if (res.status !== 200) throw new Error('http 에러');
      setOpenSnackbar(true);
      setDialogMessage('엑셀 업로드로 등록했습니다.');
      return res.data;
    });
  };

  const saveBookGroupInfo = () => {
    if (bookGroupName === '') {
      setOpenDialog(true);
      setDialogMessage('제목을 입력헤주세요');
      return;
    }
    if (tabValue === 0 && (schoolGroupSeq === 0 || schoolSeq === 0)) {
      setOpenDialog(true);
      setDialogMessage('대상 학교를 지정해주세요');
      return;
    }
    if (tabValue === 1 && schoolGroupSeq === 0) {
      setOpenDialog(true);
      setDialogMessage('대상 학군를 지정해주세요');
      return;
    }
    if (
      uploadFile === undefined ||
      uploadFile === null ||
      uploadFile.file === undefined ||
      uploadFile.file === null
    ) {
      setOpenDialog(true);
      setDialogMessage('추천 도서 파일을 업로드해주세요.');
      return;
    }

    const newItem: any = {
      tabValue: tabValue,
      bookGroupSeq: bookGroupSeq,
      bookGroupName: bookGroupName,
      description: description,
      schoolClassSeq: schoolClassSeq,
      educationOfficeSeq: educationOfficeSeq,
      schoolSeq: schoolSeq,
      schoolGroupSeq: schoolGroupSeq,
      schoolGrade: schoolGrade,
      schoolClass: schoolClass !== '0' ? schoolClass : customSchoolClass,
      uploadFile: uploadFile,
      imageUrl: imageUrl,
    };
    onSave(newItem);
    onClose();
  };

  const deleteBookGroupInfo = () => {
    const newItem: any = {
      bookGroupSeq: bookGroupSeq,
    };
    onDelete(newItem);
    onClose();
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    loginVal.value.user.roleName === '일반'
      ? setTabValue(0)
      : setTabValue(newValue);
  };

  const handleSchoolGradeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSchoolGrade(Number(event.target.name));
  };

  const handleUploadFile = (targetFile: any) => {
    const newImage = {
      name: targetFile.name,
      file: targetFile,
      fname: targetFile.name,
    };
    setUploadFile(newImage);
  };

  useEffect(() => {
    reloadSchools(schoolList, schoolGroupSeq, 0);
  }, [schoolGroupSeq]);

  useEffect(() => {
    schoolClassRefetch();
  }, [schoolSeq, schoolGrade]);

  useEffect(() => {
    setEducationOfficeSeq(loginVal.value.user.educationOfficeSeq);
    setSchoolGroupSeq(loginVal.value.user.schoolGroupSeq);
    setSchoolSeq(loginVal.value.user.schoolSeq);
    setSchoolGrade(loginVal.value.user.schoolGrade ?? 0);
    if (loginVal.value.user.schoolClass === null) {
      setSchoolClass('0');
    } else if (!Number.isNaN(Number(loginVal.value.user.schoolClass))) {
      setSchoolClass(loginVal.value.user.schoolClass);
    } else {
      setSchoolClass(loginVal.value.user.schoolClass);
      setCustomSchoolClass(loginVal.value.user.schoolClass);
    }
  }, [loginVal]);

  useEffect(() => {
    if (open && !isAdd && bookGroupInfo) {
      setBookGroupSeq(bookGroupInfo.bookGroupSeq);
      setBookGroupName(bookGroupInfo.bookGroupName);
      setDescription(bookGroupInfo.description);
      setSchoolClassSeq(
        bookGroupInfo.schoolClassSeq !== null ? bookGroupInfo.schoolClassSeq : 0
      );
      setEducationOfficeSeq(
        bookGroupInfo.educationOfficeSeq !== null
          ? bookGroupInfo.educationOfficeSeq
          : 0
      );
      setSchoolGroupSeq(
        bookGroupInfo.schoolGroupSeq !== null ? bookGroupInfo.schoolGroupSeq : 1
      );
      setSchoolName(bookGroupInfo.schoolName);
      setSchoolSeq(bookGroupInfo.schoolSeq);
      setSchoolGrade(
        bookGroupInfo.schoolGrade !== null ? bookGroupInfo.schoolGrade : 0
      );
      if (bookGroupInfo.schoolClass === null) {
        setSchoolClass('0');
      } else if (!Number.isNaN(Number(bookGroupInfo.schoolClass))) {
        setSchoolClass(bookGroupInfo.schoolClass);
      } else {
        setSchoolClass(loginVal.value.user.schoolClass);
        setCustomSchoolClass(bookGroupInfo.schoolClass);
      }
      setImageUrl(bookGroupInfo.imageUrl);
      setTabValue(bookGroupInfo.schoolGroupSeq === null ? 0 : 1);
    } else if (open && isAdd) {
      setEducationOfficeSeq(loginVal.value.user.educationOfficeSeq);
      setSchoolGroupSeq(loginVal.value.user.schoolGroupSeq);
      setSchoolSeq(loginVal.value.user.schoolSeq);
      setSchoolGrade(loginVal.value.user.schoolGrade ?? 0);
      if (loginVal.value.user.schoolClass === null) {
        setSchoolClass('0');
      } else if (!Number.isNaN(Number(loginVal.value.user.schoolClass))) {
        setSchoolClass(loginVal.value.user.schoolClass);
      } else {
        setSchoolClass(loginVal.value.user.schoolClass);
        setCustomSchoolClass(loginVal.value.user.schoolClass);
      }
      setBookGroupSeq(0);
      setBookGroupName('');
      setDescription('');
      setSchoolClassSeq(0);
      setSchoolName('');
      setImageUrl('');
      setTabValue(0);
    } else {
      setEducationOfficeSeq(1);
      setSchoolGroupSeq(1);
      setSchoolSeq(0);
      setSchoolGrade(1);
      setSchoolClass('1');
      setBookGroupSeq(0);
      setBookGroupName('');
      setDescription('');
      setSchoolClassSeq(0);
      setSchoolName('');
      setImageUrl('');
      setTabValue(0);
      setCustomSchoolClass('');
    }

    if (open) {
      const savedSchoolList = localStorage.getItem(KEY_SCHOOL_LIST);
      if (savedSchoolList) {
        const newSchoolList = JSON.parse(savedSchoolList);
        setSchoolList(newSchoolList);
        reloadSchools(newSchoolList, schoolGroupSeq, 0);
      }
    }
  }, [open]);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            minHeight: '56vh',
            minWidth: '24vw',
          },
        }}
      >
        <DialogTitle>
          <Box className='flex_between'>
            <Box>
              <Typography className='title'>
                {isAdd ? '데이터 추가' : '데이터 조회/수정'}
              </Typography>
            </Box>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <Divider sx={{ m: 0, p: 0 }} />
        <DialogContent>
          <Box>
            <Typography className='title'>이미지</Typography>
            <Box className='flex_start'>
              <SwImageBox
                src={
                  imageUrl && imageUrl.length > 0
                    ? `${loginVal.value.user.cloudFront}${imageUrl}`
                    : ''
                }
                onDelete={() => {
                  setOpenBookGroupCategory(true);
                }}
              />
            </Box>
          </Box>
          <Divider />
          <Box>
            <Typography className='title'>제목</Typography>
            <Box className='flex_start'>
              <TextField
                placeholder='도서 목록의 제목을 입력해 주세요.(최대 30자)'
                sx={{ width: '20rem', mr: '.5rem' }}
                value={bookGroupName}
                onChange={evt => setBookGroupName(evt.target.value)}
              />
            </Box>
          </Box>
          <Divider />
          <Box>
            <Typography className='title'>설명</Typography>
            <Box className='flex_start'>
              <TextField
                placeholder='도서 목록의 제목을 입력해 주세요.(최대 30자)'
                sx={{ width: '20rem', mr: '.5rem' }}
                value={description}
                onChange={evt => setDescription(evt.target.value)}
              />
            </Box>
          </Box>
          <Divider />
          <Box>
            <Typography className='title'>추천 도서 대상</Typography>
            <Box sx={{ mb: '.5rem', borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tabValue} onChange={handleChange} centered>
                <Tab label='학교/학급 지정' sx={{ width: '15rem' }} />
                <Tab
                  disabled={loginVal.value.user.roleName === '일반'}
                  label='학군/학년 지정'
                  sx={{ width: '15rem' }}
                />
              </Tabs>
            </Box>
            {tabValue === 0 ? (
              <Box>
                <Typography className='title'>대상 학교</Typography>
                <Box className='flex_start'>
                  <TextField
                    disabled={
                      loginVal.value.user.roleName === '일반' ||
                      loginVal.value.user.roleName === '관리자1'
                    }
                    sx={{ width: '15rem' }}
                    select
                    value={schoolGroupSeq}
                    onChange={evt => {
                      setSchoolGroupSeq(Number(evt.target.value));
                      setSchoolSeq(0);
                    }}
                  >
                    <MenuItem key={`school_${0}`} value={0}>
                      초/중/고 선택
                    </MenuItem>
                    {schoolGroups.map((item: any, idx: number) => (
                      <MenuItem key={`school_level_${idx}`} value={item.seq}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    disabled={
                      loginVal.value.user.roleName === '일반' ||
                      loginVal.value.user.roleName === '관리자1'
                    }
                    sx={{ width: '15rem', ml: '.5rem' }}
                    select
                    value={schoolSeq}
                    onChange={evt => setSchoolSeq(Number(evt.target.value))}
                  >
                    <MenuItem key={`school_${0}`} value={0}>
                      선택
                    </MenuItem>
                    {schools &&
                      schools.map((item: any, idx: number) => (
                        <MenuItem key={`school_${idx}`} value={item.schoolSeq}>
                          {item.schoolName}
                        </MenuItem>
                      ))}
                  </TextField>
                </Box>
                <Divider />
                <Typography className='title'>대상 학급</Typography>
                <Box className='flex_start'>
                  <TextField
                    disabled={loginVal.value.user.roleName === '일반'}
                    sx={{ width: '15rem', mr: '.5rem' }}
                    select
                    value={schoolGrade}
                    onChange={evt => setSchoolGrade(Number(evt.target.value))}
                  >
                    <MenuItem key='school_class_0' value={0}>
                      전체
                    </MenuItem>
                    {Array.from(
                      { length: getSchoolGradeCount(schoolGroupSeq) },
                      (_, index) => (
                        <MenuItem
                          key={`school_grade_${index + 1}`}
                          value={index + 1}
                        >
                          {`${index + 1} 학년`}
                        </MenuItem>
                      )
                    )}
                  </TextField>
                  {schoolGrade !== 0 &&
                  schoolClassList !== null &&
                  schoolClassList.length > 0 ? (
                    <TextField
                      disabled={loginVal.value.user.roleName === '일반'}
                      sx={{ width: '10rem' }}
                      select
                      value={schoolClass}
                      onChange={evt => setSchoolClass(evt.target.value)}
                    >
                      {schoolClassList.map((sc: string, index: number) => (
                        <MenuItem key={`school_class_${index + 1}`} value={sc}>
                          {`${sc} 반`}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : (
                    <TextField
                      disabled={loginVal.value.user.roleName === '일반'}
                      sx={{ width: '10rem' }}
                      select
                      value={schoolClass}
                      onChange={evt => setSchoolClass(evt.target.value)}
                    >
                      <MenuItem key='school_class_0' value='0'>
                        전체
                      </MenuItem>
                      {Array.from(
                        { length: getSchoolClassCount() },
                        (_, index) => (
                          <MenuItem
                            key={`school_class_${index + 1}`}
                            value={index + 1}
                          >
                            {`${index + 1} 반`}
                          </MenuItem>
                        )
                      )}
                      {customSchoolClass !== '' && (
                        <MenuItem key='school_class_0' value='0'>
                          {customSchoolClass}
                        </MenuItem>
                      )}
                    </TextField>
                  )}
                </Box>
              </Box>
            ) : (
              <Box>
                <Box>
                  <Typography className='title'>대상 학군</Typography>
                  <Box>
                    <RadioGroup
                      row
                      aria-labelledby='movie-row-radio-buttons-group-label'
                      name='scholl-group-radio-buttons-group'
                      value={schoolGroupSeq}
                      onChange={evt => {
                        setSchoolGroupSeq(Number(evt.currentTarget.value));
                      }}
                    >
                      <FormControlLabel
                        disabled={loginVal.value.user.roleName === '관리자1'}
                        value={1}
                        control={<Radio />}
                        label='초등학교'
                      />
                      <FormControlLabel
                        disabled={loginVal.value.user.roleName === '관리자1'}
                        value={2}
                        control={<Radio />}
                        label='중학교'
                      />
                      <FormControlLabel
                        disabled={loginVal.value.user.roleName === '관리자1'}
                        value={3}
                        control={<Radio />}
                        label='고등학교'
                      />
                    </RadioGroup>
                  </Box>
                </Box>
                <Divider />
                <Box>
                  <Typography className='title'>대상 학년</Typography>
                  <Box>
                    <FormControl component='fieldset' variant='standard'>
                      <FormGroup row>
                        {Array.from({ length: 3 }, (_, index) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={schoolGrade === index + 1}
                                onChange={handleSchoolGradeChange}
                                name={`${index + 1}`}
                              />
                            }
                            label={`${index + 1} 학년`}
                          />
                        ))}
                      </FormGroup>
                    </FormControl>
                  </Box>
                  {schoolGroupSeq === 1 && (
                    <Box>
                      <FormControl component='fieldset' variant='standard'>
                        <FormGroup row>
                          {Array.from({ length: 3 }, (_, index) => (
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={schoolGrade === index + 4}
                                  onChange={handleSchoolGradeChange}
                                  name={`${index + 4}`}
                                />
                              }
                              label={`${index + 4} 학년`}
                            />
                          ))}
                        </FormGroup>
                      </FormControl>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
          </Box>
          <Divider />
          <Box>
            <Typography className='title'>추천 도서 입력</Typography>
            <Box>
              <Typography>
                {uploadFile ? `파일명 : ${uploadFile.fname}` : '파일명 : '}
              </Typography>
              <Box className='flex_between' sx={{ mt: '1rem' }}>
                <Button
                  sx={{ ml: '3rem', width: '40%' }}
                  color='info'
                  variant='outlined'
                  onClick={() => downloadSampleExcel()}
                >
                  <img
                    src={excellog}
                    alt='icon'
                    style={{ marginRight: 8 }} // Adjust margin as needed
                  />
                  양식 다운로드
                </Button>
                <Button
                  sx={{ mr: '3rem', width: '40%' }}
                  color='info'
                  variant='outlined'
                  onClick={() => {
                    const imagefile = document.getElementById(
                      'upload_book_group_form_excel'
                    );
                    imagefile?.click();
                  }}
                >
                  <img
                    src={folderlog}
                    alt='icon'
                    style={{ marginRight: 8 }} // Adjust margin as needed
                  />
                  파일 업로드
                </Button>
                <input
                  className='nonedisplay'
                  id='upload_book_group_form_excel'
                  type='file'
                  onChange={(evt: ChangeEvent<HTMLInputElement>) => {
                    evt.target.files && handleUploadFile(evt.target.files[0]);
                  }}
                />
              </Box>
            </Box>
          </Box>
          <Divider />
        </DialogContent>
        <Divider sx={{ m: 0, p: 0 }} />
        <DialogActions>
          {isAdd ? (
            <Button
              variant='contained'
              color='info'
              sx={{ fontSize: '.87rem' }}
              onClick={saveBookGroupInfo}
            >
              등록
            </Button>
          ) : (
            <Box>
              <Button
                variant='outlined'
                color='info'
                sx={{ fontSize: '.87rem', mr: '.5rem' }}
                onClick={() => setOpenConfirm(2)}
              >
                삭제
              </Button>
              <Button
                variant='contained'
                color='info'
                sx={{ fontSize: '.87rem' }}
                onClick={() => setOpenConfirm(1)}
              >
                저장
              </Button>
            </Box>
          )}
        </DialogActions>
      </Dialog>
      <SwSnackbar
        open={openSnackbar}
        onClose={() => setOpenSnackbar(false)}
        contents={dialogMessage}
      />
      <SwAlert
        open={openDialog}
        onConfirm={() => setOpenDialog(false)}
        contents={dialogMessage}
      />
      <SwConfirmDialog
        contents={openConfirm === 1 ? '저장하시겠습니까?' : '삭제하시겠습니까?'}
        open={openConfirm !== 0}
        onClose={() => setOpenConfirm(0)}
        onConfirm={() => {
          openConfirm === 1 ? saveBookGroupInfo() : deleteBookGroupInfo();
          setOpenConfirm(0);
        }}
        confirm={1}
      />
      <SwThumbImageCategoryView
        setImageUrl={setImageUrl}
        open={openBookGroupCategory}
        onClose={() => setOpenBookGroupCategory(false)}
      />
    </>
  );
};
